import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FileModel } from '../models/file';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  // private baseUrl = window.location.origin + '/File';
  private baseUrl = environment.baseUrl+ '/File';

  constructor(private http: HttpClient) {
  }

  getDownloadUrl(id: string): string {
    return `${this.baseUrl}?id=${id}`;
  }

  getViewUrl(id: string): string {
    return `${this.baseUrl}/view/${id}`;
  }

  getDetails(id: string): Observable<FileModel> {
    return this.http.get<FileModel>(`${this.baseUrl}/details?id=${id}`);
  }

  uploadFile(formData: FormData): Observable<FileModel> {
    return this.http.post<FileModel>(this.baseUrl, formData);
  }

  deleteFile(id: string): Observable<string> {
    return this.http.delete<string>(`${this.baseUrl}?id=${id}`);
  }
}
